module.exports = __webpack_public_path__ + "img/user-placeholder.8fe588f0.png";